import Button from './button';
export { SizeType as ButtonSize } from '../config-provider/SizeContext';
export { ButtonProps, ButtonShape, ButtonType } from './button';
export { ButtonGroupProps } from './button-group';
export default Button;
